/**
 * @prettier
 */

import React from 'react';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';
import LetterpressImage from 'assets/images/filters/letterpress.jpg';
import { formatPrice } from '../../../../../components/product/helpers';
import { hideModal } from '../../../../actions/modalActions';
import styles from './styles.module.less';

const Description = ({ title, body }) => {
  return (
    <div>
      <div className={styles.descriptionTitle}>{title}</div>
      <div className={styles.descriptionBody}>{body}</div>
    </div>
  );
};

export const LetterpressLearnMoreBase = ({ basePrice, onConfirm }) => {
  const formattedBasePrice = typeof basePrice === 'number' && formatPrice(basePrice, null, 2);

  return (
    <div className={styles.box}>
      <div className={styles.title}>What&apos;s Letterpress?</div>
      <div
        className={styles.image}
        style={{
          backgroundImage: `url(${LetterpressImage})`,
        }}
      />
      <div className={styles.body}>
        {formattedBasePrice && <div className={styles.price}>From {formattedBasePrice} Ea.</div>}
        <div className={styles.description}>
          This printing method uses raised, inked surfaces to press designs onto paper and create
          crisp impressions.
        </div>
        <div className={styles.description}>
          <Description
            title="Feels Like"
            body="Slight indentations on luxurious, extra-thick paper"
          />
          <Description
            title="Ideal For"
            body="Designs with fine details with small areas of solid color"
          />
          <Description
            title="Why We Love It"
            body="Designs with fine details with small areas of solid color"
          />
        </div>
        <div className={styles.button}>
          <div className={styles.buttonWrapper}>
            <ButtonV2 fullWidth onClick={onConfirm}>
              Got it
            </ButtonV2>
          </div>
        </div>
      </div>
    </div>
  );
};

export const mapDispatchToProps = dispatch => ({
  onConfirm: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(LetterpressLearnMoreBase);



// WEBPACK FOOTER //
// ./src/cards/components/common/Letterpress/LetterpressLearnMore/LetterpressLearnMore.jsx